import groq from "groq"

export const groqBranchOfficeProjection = () => groq`
    "emailPayment": emailPaymentMethod,
    "emailGeneral": emailInfo,

    deliveryAddress {
        ...,
        "name": name1,
        "nameAddition": name2,
        "city": place,
        "zipCode": zip,
    },
    billingAddress {
        ...,
        "name": name1,
        "nameAddition": name2,
        "city": place,
        "zipCode": zip,
    },
    logisticsChain[]->{
     id
    }
`
